/**
 * "Fale com a gente".
 *
 * A form rather than a mailto, so no address is ever in the page to be
 * scraped. The message goes through the API, which sends it on from our own
 * verified sender. Leaving your e-mail is optional and it is only used as a
 * Reply-To, nothing is stored.
 */

import { useState } from 'react';
import { api, ApiError } from '../api.js';
import { Shell } from '../components/Brand.js';

export function Contact() {
  const [name, setName] = useState('');
  const [replyTo, setReplyTo] = useState('');
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (sent) {
    return (
      <Shell>
        <div className="page">
          <div className="banner ok">Mensagem enviada. Obrigado!</div>
          <p className="muted">
            {replyTo
              ? 'Se precisar de resposta, respondemos no e-mail que você deixou.'
              : 'Você não deixou e-mail, então não conseguimos responder. Mas lemos tudo.'}
          </p>
          <a className="button block" href="/">
            Voltar
          </a>
        </div>
      </Shell>
    );
  }

  async function submit() {
    setBusy(true);
    setError(null);
    try {
      await api.post('/api/contato', { name, replyTo, message });
      setSent(true);
    } catch (err) {
      setError(
        err instanceof ApiError ? err.message : 'Não conseguimos enviar agora.',
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <Shell>
      <div className="page">
        <h1>Fale com a gente</h1>
        <p className="muted">
          Dúvida, problema ou ideia? Escreva abaixo.
        </p>

        {error && <div className="banner error">{error}</div>}

        <label htmlFor="c-name">Seu nome (opcional)</label>
        <input
          id="c-name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <label htmlFor="c-email">Seu e-mail (opcional)</label>
        <input
          id="c-email"
          type="email"
          inputMode="email"
          value={replyTo}
          onChange={(e) => setReplyTo(e.target.value)}
          placeholder="só se quiser resposta"
        />

        <label htmlFor="c-message">Mensagem</label>
        <textarea
          id="c-message"
          rows={6}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />

        <div className="sticky-action">
          <button
            className="primary"
            onClick={submit}
            disabled={busy || message.trim().length < 5}
          >
            {busy ? 'Enviando…' : 'Enviar'}
          </button>
        </div>
      </div>
    </Shell>
  );
}
